import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import StripeCardBox from './StripeCardBox';

const StripeCard = ({ onSaveCard, loading, setLoading,publicKey }) => {
  const stripePromise = loadStripe(publicKey || "");

  return (
    <Elements stripe={stripePromise}>
      <StripeCardBox
        onSaveCard={onSaveCard}
        loading={loading}
        setLoading={setLoading}
      />
    </Elements>
  )
}

export default StripeCard